import { render, staticRenderFns } from "./FolderTreeItem.vue?vue&type=template&id=4e509f5b&scoped=true&"
import script from "./FolderTreeItem.vue?vue&type=script&lang=js&"
export * from "./FolderTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderTreeItem.vue?vue&type=style&index=0&id=4e509f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e509f5b",
  null
  
)

export default component.exports